import * as React from "react"
import styled, { css } from "styled-components"

import FunctionLink from "~/components/atoms/FunctionLink"
import { Color, IsMobile } from "~/consts/style-mixins"

interface Props {
  children: React.ReactNode | React.ReactNode[]
  cutPoint: number
}

const { useState } = React

const RecruitmentListcut = ({ children, cutPoint }: Props) => {
  const [fullItems, displayedFull] = useState(Array.isArray(children) ? children.length <= cutPoint : true)

  return (
    <>
      {fullItems ? (
        children
      ) : (
        <>
          {Array.isArray(children) && children.slice(0, cutPoint)}
          <StyledDisplayMoreWrapper>
            <StyledDisplayMore size="Medium" isButton={true} onClick={() => displayedFull(true)}>
              もっと見る
            </StyledDisplayMore>
          </StyledDisplayMoreWrapper>
        </>
      )}
    </>
  )
}

const StyledDisplayMoreWrapper = styled.div`
  width: 280px;
  margin: 0 auto;
  ${IsMobile(css`
    padding-right: 16px;
  `)}
`

const StyledDisplayMore = styled(FunctionLink)`
  width: 280px;
  min-width: 280px;
  max-height: 48px;
  margin: 0 auto;
  display: block;
  font-weight: bold;
  color: ${Color.Secondary};
  &:hover {
    cursor: pointer;
  }
`

export default RecruitmentListcut
